import { useCallback, useState } from "react";
import ReceiptModal from "../../../Components/Molecules/ReceiptModal";
import { ExtractTransactionDetailModal } from "../Extract/ExtractTransactionDetailModal";
import { PixRefundModal } from "./PixRefundModal";
import { canRefundPixRecebimento } from "./pixStatementFilters";

/**
 * Shared detail + Estornar flow for any screen that lists IB statement rows
 * (Home, Extrato, Pix, Comprovantes, Estornos, ReceiptList / Organizers).
 */
export const usePixStatementDetailFlow = ({
  refundEnabled = true,
  onRefundSuccess,
} = {}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [refundItem, setRefundItem] = useState(null);
  const [refundOpen, setRefundOpen] = useState(false);
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [receiptItem, setReceiptItem] = useState({});
  const [receiptType, setReceiptType] = useState("receipts");

  const openDetails = useCallback((item) => {
    setSelectedItem(item);
    setDetailOpen(true);
  }, []);

  const closeDetails = useCallback(() => {
    setDetailOpen(false);
    setSelectedItem(null);
  }, []);

  const openRefund = useCallback((item) => {
    setDetailOpen(false);
    setSelectedItem(null);
    setRefundItem(item);
    setRefundOpen(true);
  }, []);

  const closeRefund = useCallback(() => {
    setRefundOpen(false);
    setRefundItem(null);
  }, []);

  const handleRefundSuccess = useCallback(() => {
    setRefundOpen(false);
    setRefundItem(null);
    setDetailOpen(false);
    setSelectedItem(null);
    onRefundSuccess?.();
  }, [onRefundSuccess]);

  const openReceipt = useCallback((item, type) => {
    setReceiptItem(item?.receipt ?? {});
    setReceiptType(type);
    setDetailOpen(false);
    setReceiptOpen(true);
  }, []);

  const closeReceipt = useCallback(() => {
    setReceiptOpen(false);
    setReceiptItem({});
    setSelectedItem(null);
  }, []);

  const canRefund = useCallback(
    (item) => canRefundPixRecebimento(item, { refundEnabled }),
    [refundEnabled],
  );

  const detailModals = (
    <>
      <ExtractTransactionDetailModal
        open={detailOpen}
        onClose={closeDetails}
        item={selectedItem}
        onViewReceipt={openReceipt}
        refundEnabled={refundEnabled}
        onRefund={openRefund}
      />

      <PixRefundModal
        open={refundOpen}
        item={refundItem}
        onClose={closeRefund}
        onSuccess={handleRefundSuccess}
      />

      <ReceiptModal
        type={receiptType}
        open={receiptOpen}
        onClose={closeReceipt}
        selectedItem={receiptItem}
      />
    </>
  );

  return {
    refundEnabled,
    canRefund,
    openDetails,
    openRefund,
    detailModals,
  };
};
